module.exports = __webpack_public_path__ + "images/emoji/mute.036087010f9769e4e4a1.png";